import { colors } from 'config/styled-theme'
import React from 'react'
import { CSSProperties } from 'styled-components'
import style from './Dots.module.scss'

interface Props {
    children: React.ReactNode
    className?: string
    color?: string
}

const Dots = ({ children, className, color = colors.academy }: Props): JSX.Element => (
    <ul style={{'--dotFillColor': color} as CSSProperties} className={style(style.dots, className)}>{children}</ul>
)

Dots.defaultProps = {
    className: '',
}

export default Dots
